import {ErrorCircleFilled} from "@fluentui/react-icons";
import {Column, Row} from "./Layout";
import {Image} from "@fluentui/react-components";
import failureIcon from "../../../assets/ver3/nbt/failure.png";
import {useCommonPageStyles} from "../../../styles/mission/commonStyle";
import {getCurrentSubDomain} from "../../HomePage";

export function ErrorPage() {

    const style= useCommonPageStyles()
    const currentSubDomain = getCurrentSubDomain();

    if(currentSubDomain === "nbt" || currentSubDomain.includes("toktokquiz")){
        return <div className={style.nbt_root}>
            <Image alt={"failure_icon"} src={failureIcon}/>
            <div className={style.textStyle}>
                죄송합니다.<br/>
                <br/>
                에러가 발생하여 정상적으로 처리되지 못했습니다. <br/>
                새로고침하여 다시 접속해주시길 부탁드립니다.<br/>
                감사합니다.
            </div>
        </div>
    }
    else {
    return <Column gap={'16px'} alignItems={'center'} justifyContent={'center'}>
        <div style={{height: '96px'}}/>
        <ErrorCircleFilled fontSize={'200px'} color={'black'}/>
        <Row>
            죄송합니다.
        </Row>
        <Row>
            에러가 발생하여 정상적으로 처리되지 못했습니다. <br/>
            새로고침 하여 다시 접속해주시길 부탁드립니다.<br/>
            감사합니다.
        </Row>
    </Column>
    }
}